import MyAgreementPage from './MyAgreementPage';

export default MyAgreementPage;
